export function NotFoundPage() {
  return (
    <section className="not-found">
      <p className="eyebrow">404</p>
      <h1>Page not found</h1>
      <p>The path may have changed, but the next conversation is close.</p>
      <a className="button" href="/">Return home</a>
    </section>
  );
}
